import { Component, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';

import { PrivaButtonComponent } from '@priva/components/button';
import { PrivaDialogComponent } from '@priva/components/dialog-simple';
import { PrivaSelectionGroupItem, PrivaSelectionGroupModule } from '@priva/components/selection-group';
import { PrivaLocalizationModule } from '@priva/localization';

import { closeDialog } from 'app/state/app-state/app-state.actions';
import { addRowToSelection, removeRowFromSelection } from 'app/state/row-selection/row-selection.actions';
import { removeScannedCodeFromFlow } from 'app/state/scan-flow/scan-flow.actions';

import { RowRegistrationStatus } from '../../features/map-row-selector/models';

interface RowStatusSelectItem extends PrivaSelectionGroupItem {
    id: RowRegistrationStatus;
}

@Component({
    selector: 'app-row-status-select-dialog',
    templateUrl: './row-status-select-dialog.component.html',
    styleUrl: './row-status-select-dialog.component.scss',
    imports: [PrivaButtonComponent, PrivaDialogComponent, PrivaLocalizationModule, PrivaSelectionGroupModule],
})
export class RowStatusSelectDialogComponent {
    private store = inject(Store);

    onDialogClosedAction: Action | undefined;
    rowNumber = 0;
    scannedCode = '';
    showRemoveButton = false;
    title = '';

    rowStatusSelectItems: RowStatusSelectItem[] = [
        {
            label: 'DIALOG.STATUS.INCOMPLETE',
            icon: 'fa-solid fa-circle-half color-warning',
            id: 'incomplete',
        },
        {
            label: 'DIALOG.STATUS.DONE',
            icon: 'fa-solid fa-circle color-success',
            id: 'done',
        },
    ];

    closeDialog() {
        this.store.dispatch(closeDialog());
        if (this.onDialogClosedAction) this.store.dispatch(this.onDialogClosedAction);
    }

    onToggle(item: PrivaSelectionGroupItem) {
        const rowStatusSelectItem = item as RowStatusSelectItem;
        if (rowStatusSelectItem) {
            this.store.dispatch(
                addRowToSelection({
                    rowNumber: this.rowNumber,
                    registrationStatus: rowStatusSelectItem.id,
                }),
            );
            this.closeDialog();
        }
    }

    removeRow() {
        this.store.dispatch(removeRowFromSelection({ rowNumber: this.rowNumber }));
        if (this.scannedCode) {
            this.store.dispatch(removeScannedCodeFromFlow({ code: this.scannedCode }));
        }
        this.closeDialog();
    }
}
